/**
 * Ключи локального хранилища
 */
export enum EStorageKeys {
  USER_MENU = 'mt-auth-user-menu',
  SYSTEM_PARAMS = 'mt-auth-system-params',
  PUBLIC_SYSTEM_PARAMS = 'mt-auth-public-system-params',
  /**
   * Ссылка редиректа после авторизации
   */
  REDIRECT_TO = 'mt-auth-redirect-subsystem-to',
  REDIRECT_AUTH_TO = 'mt-auth-redirect-to',
  AUTH_TOKENS = 'mt-auth-tokens',
  AUTH_USER = 'mt-auth-user',
  MENU_FAVORITE = 'mt-menu-favorite-key',
  CODE_VERIFIER = 'mt-auth-pkce-code-verifier',
  STATE_FOR_AUTHORIZE = 'mt-auth-state-for-authorize',
}

export const AuthClientId = 'subsystem-auth';
export const AscupClientId = 'subsystem-iasppr';
export const AscupPWAClientId = 'subsystem-iasppr-mobile';

export enum EMenuUrl {
  NSI = '/access-admin/nsi',
  USERS = '/access-admin/users',
  SYSTEM_PARAMS = '/access-admin/system-params',
  EVENT_LOG = '/access-admin/event-log',
  SYSTEM_SCENARIOS = '/access-admin/informing/system-scenarios',
  NOTIFICATION_HISTORY = '/access-admin/informing/mailings',
  NOTIFICATION_SETTINGS = '/access-admin/informing/settings',
}

export enum EMenuIcon {
  NSI = 'mt mt_sidemenu-dict',
  USERS = 'mt mt_sidemenu-users',
  SYSTEM_PARAMS = 'mt mt_sidemenu-settings',
  EVENT_LOG = 'mt mt_sidemenu-monitoring',
  INFORMING = 'mt mt_mail',
}

export enum GRID_ID {
  'ADMIN.USERS' = 'admin.users',
  'ADMIN.USERS.IP_ADDRESS' = 'admin.users.ip_address',
  'ADMIN.SYSTEM_PARAMS' = 'admin.system-params',
  'ADMIN.INFORMING.SETTINGS' = 'admin.informing.settings',
  'ADMIN.SYSTEM_PARAMS.HISTORY' = 'admin.system-params.history',
  'NSI.DICT.SUBSYSTEMS' = 'nsi.dict.subsystems',
  'ADMIN.EVENT_LOG' = 'admin.event-log',
  'ADMIN.EVENT_LOG.CARD.CHANGES' = 'admin.event-log.card.changes',
  'ADMIN.EVENT_LOG.CARD.ERRORS' = 'admin.event-log.card.errors',
}

/**
 * Ключи системных параметров
 */
export enum ESystemParameterName {
  SUPPORT_PHONE = 'SYSTEM_SUPPORT_PHONE',
  SUPPORT_EMAIL = 'SYSTEM_SUPPORT_EMAIL',
  TWO_FACTOR_CODE_LIFETIME = 'INFOSEC_TWO_FACTOR_CODE_LIFETIME',
  PASSWORD_LENGTH = 'PASSWORD_LENGTH',
  PASSWORD_UPPERCASES = 'PASSWORD_UPPERCASES',
  PASSWORD_LOWERCASES = 'PASSWORD_LOWERCASES',
  PASSWORD_NUMBERS = 'PASSWORD_NUMBERS',
  PASSWORD_SPECIAL_CHARACTERS = 'PASSWORD_SPECIAL_CHARACTERS',
  PASSWORD_CHARACTERS_TO_CHANGE = 'PASSWORD_CHARACTERS_TO_CHANGE',
}

export enum EProfileNotificationType {
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_FAIL = 'LOGIN_FAIL',
  LOGOUT = 'LOGOUT',
}

export enum EEventLogStates {
  /**
   * В процессе
   */
  PROGRESS = 'PROGRESS',
  /**
   * Завершено с ошибками
   */
  ERROR = 'ERROR',
  /**
   * Завершено успешно
   */
  OK = 'OK',
}
